import React from 'react';
import { Link } from "react-router-dom";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophoneAlt } from '@fortawesome/free-solid-svg-icons';

import "../styles/Disclaimer.css";

let isIE = /*@cc_on!@*/false || !!document.documentMode;

library.add(faMicrophoneAlt);

var Disclaimer = () => (
  <div className="disclaimer">
    <img className="background" src={require("../assets/bg-image-home.jpg")} alt="Background" />
    <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    <h1 className="pageTitle">Disclaimer</h1>
    <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
    <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
    <p className="info">The Power Quiz game has been developed by Age Scotland, with exercises that have been guided by the evidence-base, as of July 2020, with regard to physical exercises that are beneficial and safe for older adults.<br /><br />
    Participation in the activities contained in this video involves physical activity that may be strenuous for some users, please only take part in appropriate surroundings, in a safe manner and not in excess of your own abilities. Quiz Masters should read the full terms and conditions before participating, available from Age Scotland: email <a href="mailto:healthandwellbeing@agescotland.org.uk">healthandwellbeing@agescotland.org.uk</a> or call on 0333 323 2400.
    </p>
    <Link className="button" to="/selectQuiz"><FontAwesomeIcon icon="microphone-alt" /> Start</Link>
    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Footer" />
  </div>
);

if(isIE){
  Disclaimer = () => (
    <div className="ie-disclaimer">
      <div className="header-footer">
        <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
      <div className="pageContent">
        <div className="heading">
            <h1>Disclaimer</h1>
          <div className="logos">
            <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
            <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
          </div>
        </div>
        <div className="info">
          <p>The Power Quiz game has been developed by Age Scotland, with exercises that have been guided by the evidence-base, as of July 2020, with regard to physical exercises that are beneficial and safe for older adults.<br /><br />
          Participation in the activities contained in this video involves physical activity that may be strenuous for some users, please only take part in appropriate surroundings, in a safe manner and not in excess of your own abilities. Quiz Masters should read the full terms and conditions before participating, available from Age Scotland: email <a href="mailto:healthandwellbeing@agescotland.org.uk">healthandwellbeing@agescotland.org.uk</a> or call on 0333 323 2400.
          </p>
        </div>
        <div className="action">
          <Link className="button" to="/selectQuiz"><FontAwesomeIcon icon="microphone-alt" /> Start</Link>
        </div>
      </div> 
      <div className="header-footer">
        <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
    </div>
  );
} 

export default Disclaimer;
